export default __webpack_public_path__ + "static/media/elo.a93cad42.png";